import type { CheckoutQualificationAnswers } from '../lib/combinedQualification';

export interface IntakeMeasurements { biologicalSex: '' | 'male' | 'female'; heightFt: string; heightIn: string; weightLbs: string }
export interface QualificationDraft { programs?: Record<string, import("@bloom/shared").IntakeProgramSubmission>; answers: CheckoutQualificationAnswers; measurements: IntakeMeasurements }
const emptyDraft = (): QualificationDraft => ({ answers: {}, measurements: { biologicalSex: '', heightFt: '', heightIn: '', weightLbs: '' } });
// Intentionally memory-only: health answers must not enter the persisted cart or localStorage.
let cached: { scope: string; draft: QualificationDraft } | undefined;
const listeners = new Set<() => void>();
export const qualificationDraftSnapshot = () => cached;
export function subscribeQualificationDraft(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function readQualificationDraft(scope: string): QualificationDraft {
  if (cached?.scope !== scope) saveQualificationDraft(scope, emptyDraft());
  return cached!.draft;
}
export function saveQualificationDraft(scope: string, draft: QualificationDraft) {
  cached = { scope, draft };
  listeners.forEach(listener => listener());
}
export function clearQualificationDraft() { cached = undefined; listeners.forEach(listener => listener()); }
